// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/bg-pattern-light.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.authentication-bg {
    background-color: #fafbfd;
}

.account-pages {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    align-items: center;
    display: flex;
    min-height: 100vh;
}

/* Auth / Login Card Styling */
.auth-brand-logo {
    height: 36px;
    max-width: 190px;
    object-fit: contain;
    display: inline-block;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.04));
    transition: transform 0.2s ease;
}

.auth-brand-logo:hover {
    transform: scale(1.02);
}

.auth-card {
    border: 1px solid #e2e8f0 !important;
    border-radius: 18px !important;
    box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.1), 0 0 0 1px rgba(241, 245, 249, 0.8) !important;
    background: #ffffff !important;
    overflow: hidden;
}

.auth-card-subtitle {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 0;
    line-height: 1.4;
}

.auth-card-title {
    font-size: 20px;
    font-weight: 800;
    color: #0f172a;
    margin: 8px 0 4px 0;
    letter-spacing: -0.3px;
}

.auth-form-label {
    font-size: 12.5px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 6px;
    display: block;
}

.auth-forgot-link {
    font-size: 12px;
    font-weight: 600;
    color: #4f46e5;
    text-decoration: none;
    transition: color 0.15s ease;
}

.auth-forgot-link:hover {
    color: #3730a3;
    text-decoration: underline;
}

.auth-input-wrap {
    position: relative;
    display: flex;
    align-items: center;
}

.auth-input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 14px;
    pointer-events: none;
    transition: color 0.2s ease;
}

.auth-input-field {
    width: 100%;
    height: 44px;
    padding: 8px 14px 8px 38px !important;
    border-radius: 10px !important;
    border: 1.5px solid #e2e8f0 !important;
    background: #f8fafc !important;
    color: #0f172a !important;
    font-size: 13.5px !important;
    font-weight: 500;
    outline: none !important;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.auth-input-field:focus {
    background: #ffffff !important;
    border-color: #4f46e5 !important;
    box-shadow: 0 0 0 3.5px rgba(79, 70, 229, 0.15) !important;
}

.auth-input-wrap:focus-within .auth-input-icon {
    color: #4f46e5;
}

.auth-password-toggle {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #94a3b8;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    transition: color 0.15s ease;
}

.auth-password-toggle:hover {
    color: #334155;
}

.auth-checkbox {
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.auth-checkbox input[type="checkbox"] {
    cursor: pointer;
    border-color: #cbd5e1;
    border-radius: 4px;
}

.auth-checkbox input[type="checkbox"]:checked {
    background-color: #4f46e5;
    border-color: #4f46e5;
}

.btn-auth-primary {
    height: 44px;
    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 50%, #4338ca 100%) !important;
    border: none !important;
    border-radius: 10px !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    letter-spacing: 0.3px;
    box-shadow: 0 8px 20px -4px rgba(79, 70, 229, 0.45) !important;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;
    cursor: pointer;
}

.btn-auth-primary:hover:not(:disabled) {
    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 50%, #3730a3 100%) !important;
    box-shadow: 0 12px 26px -4px rgba(79, 70, 229, 0.55) !important;
    transform: translateY(-2px);
    color: #ffffff !important;
}

.btn-auth-primary:active:not(:disabled) {
    transform: translateY(0);
}

.btn-auth-primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAA6D;IAC7D,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,kDAAkD;IAClD,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,kGAAkG;IAClG,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,8BAA8B;IAC9B,sCAAsC;IACtC,8BAA8B;IAC9B,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;IAChB,wBAAwB;IACxB,6DAA6D;AACjE;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,0DAA0D;AAC9D;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qFAAqF;IACrF,uBAAuB;IACvB,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,8DAA8D;IAC9D,6DAA6D;IAC7D,eAAe;AACnB;;AAEA;IACI,qFAAqF;IACrF,+DAA+D;IAC/D,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.authentication-bg {\n    background-color: #fafbfd;\n}\n\n.account-pages {\n    background-image: url('./assets/images/bg-pattern-light.svg');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 100%;\n    align-items: center;\n    display: flex;\n    min-height: 100vh;\n}\n\n/* Auth / Login Card Styling */\n.auth-brand-logo {\n    height: 36px;\n    max-width: 190px;\n    object-fit: contain;\n    display: inline-block;\n    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.04));\n    transition: transform 0.2s ease;\n}\n\n.auth-brand-logo:hover {\n    transform: scale(1.02);\n}\n\n.auth-card {\n    border: 1px solid #e2e8f0 !important;\n    border-radius: 18px !important;\n    box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.1), 0 0 0 1px rgba(241, 245, 249, 0.8) !important;\n    background: #ffffff !important;\n    overflow: hidden;\n}\n\n.auth-card-subtitle {\n    font-size: 13px;\n    font-weight: 500;\n    color: #64748b;\n    margin-bottom: 0;\n    line-height: 1.4;\n}\n\n.auth-card-title {\n    font-size: 20px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 8px 0 4px 0;\n    letter-spacing: -0.3px;\n}\n\n.auth-form-label {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: #334155;\n    margin-bottom: 6px;\n    display: block;\n}\n\n.auth-forgot-link {\n    font-size: 12px;\n    font-weight: 600;\n    color: #4f46e5;\n    text-decoration: none;\n    transition: color 0.15s ease;\n}\n\n.auth-forgot-link:hover {\n    color: #3730a3;\n    text-decoration: underline;\n}\n\n.auth-input-wrap {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.auth-input-icon {\n    position: absolute;\n    left: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n    font-size: 14px;\n    pointer-events: none;\n    transition: color 0.2s ease;\n}\n\n.auth-input-field {\n    width: 100%;\n    height: 44px;\n    padding: 8px 14px 8px 38px !important;\n    border-radius: 10px !important;\n    border: 1.5px solid #e2e8f0 !important;\n    background: #f8fafc !important;\n    color: #0f172a !important;\n    font-size: 13.5px !important;\n    font-weight: 500;\n    outline: none !important;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;\n}\n\n.auth-input-field:focus {\n    background: #ffffff !important;\n    border-color: #4f46e5 !important;\n    box-shadow: 0 0 0 3.5px rgba(79, 70, 229, 0.15) !important;\n}\n\n.auth-input-wrap:focus-within .auth-input-icon {\n    color: #4f46e5;\n}\n\n.auth-password-toggle {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    color: #94a3b8;\n    font-size: 14px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n    transition: color 0.15s ease;\n}\n\n.auth-password-toggle:hover {\n    color: #334155;\n}\n\n.auth-checkbox {\n    font-size: 13px;\n    font-weight: 500;\n    color: #475569;\n    cursor: pointer;\n    user-select: none;\n}\n\n.auth-checkbox input[type=\"checkbox\"] {\n    cursor: pointer;\n    border-color: #cbd5e1;\n    border-radius: 4px;\n}\n\n.auth-checkbox input[type=\"checkbox\"]:checked {\n    background-color: #4f46e5;\n    border-color: #4f46e5;\n}\n\n.btn-auth-primary {\n    height: 44px;\n    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 50%, #4338ca 100%) !important;\n    border: none !important;\n    border-radius: 10px !important;\n    color: #ffffff !important;\n    font-size: 14px !important;\n    font-weight: 700 !important;\n    letter-spacing: 0.3px;\n    box-shadow: 0 8px 20px -4px rgba(79, 70, 229, 0.45) !important;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;\n    cursor: pointer;\n}\n\n.btn-auth-primary:hover:not(:disabled) {\n    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 50%, #3730a3 100%) !important;\n    box-shadow: 0 12px 26px -4px rgba(79, 70, 229, 0.55) !important;\n    transform: translateY(-2px);\n    color: #ffffff !important;\n}\n\n.btn-auth-primary:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.btn-auth-primary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
